import axios from 'axios';
import ApiConfig from './ApiConfig';

const ADD_AUTH_TOKEN = false;
const USE_OLD_TENANT_HEADER = true;

class OptimizelyService {
  baseApiUrl = process.env.OPTIMIZELY_BIGQUERY_URL;

  getVariationState() {
    return axios.get(
      `${this.baseApiUrl}/g/state`,
      ApiConfig.getHttpConfig(ADD_AUTH_TOKEN, USE_OLD_TENANT_HEADER)
    );
  }

  setVariationState(state) {
    return axios.post(
      `${this.baseApiUrl}/s/state`,
      { state: JSON.stringify(state) },
      this.getPostConfig());
  }

  getPostConfig() {
    const postConfig = ApiConfig.getHttpConfig(ADD_AUTH_TOKEN, USE_OLD_TENANT_HEADER);
    postConfig.headers['Content-Type'] = 'application/json';
    return postConfig;
  }
}

export default new OptimizelyService();


// WEBPACK FOOTER //
// ./src/app/admin/services/api/OptimizelyService.js